import firebase from 'firebase';
const config = {
  apiKey: 'AIzaSyDpJ8DKEgO7lSfW2vom-1-_sUK4cuEXOAk',
  authDomain: 'appointmentapp-d8450.firebaseapp.com',
  projectId: 'appointmentapp-d8450',
  storageBucket: 'appointmentapp-d8450.appspot.com',
  messagingSenderId: '991895977147',
  appId: '1:991895977147:web:f997902bf7bd3f7c1b7d9e',
  measurementId: 'G-4JMFM67FCZ',
};
firebase.initializeApp(config);

export default firebase;
